import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import project1 from "../assets/project1.png";
import project2 from "../assets/project2.png";
import project3 from "../assets/project3.png";

const projects = [
  {
    id: 1,
    image: project1,
    // title: "Project One",
    // description: "Modern warehouse facility with top security.",
  },
  {
    id: 2,
    image: project2,
    // title: "Project Two",
    // description: "Industrial plant with high-tech automation.",
  },
  {
    id: 3,
    image: project3,
    // title: "Project Three",
    // description: "Efficient logistics and storage solutions.",
  },
];

const ProjectSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <Slider {...settings} className="w-full">
      {projects.map((project) => (
        <div key={project.id} className="p-4">
          <img
            src={project.image}
            alt={project.title}
            className="w-full h-64 object-cover rounded-lg shadow-md"
          />
          <div className="mt-4 text-center">
            <h3 className="text-xl font-semibold">{project.title}</h3>
            <p className="text-gray-600">{project.description}</p>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default ProjectSlider;
